import React, { useState } from "react";
import { Badge, Button, Form } from "react-bootstrap";
import { useSelector } from "react-redux";
import Fontstyling from "../../../components/common/comman";
import toastFile from "../../../Service/ToastFile";
import {
  GetServiceRequestByUserId,
  RFPOperationServiceRequest,
} from "../../../api/EmpowRxApi";
import CustomMaterialTable from "../../../components/common/CustomMaterialTable";
import { useEffect } from "react";

const column = [
  { title: "Requested Date", field: "Created_date", type: "date" },
  {
    title: "Status",
    field: "status",
    render: (item) => {
      let badgeColor;
      switch (item.IsApproved) {
        case 1:
          item.status = "Approved";
          badgeColor = "primary";
          break;
        case 2:
          item.status = "Rejected";
          badgeColor = "danger";
          break;
        case 0:
          item.status = "Pending";
          badgeColor = "warning";
          break;
      }
      return (
        <Badge
          pill
          className="fw-normal py-1 px-3"
          bg={badgeColor || "warning"}
          style={{ fontSize: "10px" }}
        >
          {item.status}
        </Badge>
      );
    },
  },
];

const EmpoweRxRequest = () => {
  const user = useSelector((state) => state.userDetails.value);
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isGetData, setIsgetData] = useState(false);

  useEffect(() => {
    getData();
  }, [isGetData]);

  const getData = () => {
    setIsLoading(true);
    GetServiceRequestByUserId(user?.UD_emp_email)
      .then((res) => {
        if (res?.status === 200 || res?.status === 204) {
          if (res.data.data === null) {
            setData([]);
          } else {
            setData(res.data.data);
          }
        }
      })
      .catch((err) => console.log({ err }))
      .finally((res) => setIsLoading(false));
  };

  const onSubmit = () => {
    RFPOperationServiceRequest(user?.UD_emp_email).then((res) => {
      if (res.data.issuccess) {
        toastFile(
          res.data.message === "Request raise successfully"
            ? "Requested successfully"
            : res.data.message,
          "success"
        );
        setIsgetData((prev) => !prev);
      } else {
        toastFile(res.data.message, "error");
      }
    });
  };
  return (
    <div>
      <div className="d-flex align-item-center justify-content-between py-3 border-bottom">
        <div style={Fontstyling.heading}>Request access to EmpoweRx</div>
        <Button
          type="button"
          style={Fontstyling.savebutton}
          disabled={data.length !== 0}
          onClick={() => onSubmit()}
        >
          Request Now
        </Button>
      </div>
      <CustomMaterialTable
        overrideColumn={column}
        data={data}
        isLoading={isLoading}
        isEdit={false}
        isDelete={false}
        isExport={false}
      />
    </div>
  );
};

export default EmpoweRxRequest;
